import qs from 'qs'
import _ from 'lodash'
import { IImageUpload } from '@protocol/image'
import http from '@services/http'
import { GlobalStoreKey, V2_API_URL, V2_API_HEADER } from '@v2/constants/common'
import { SimpleMatchTimelineGroup } from '@interface/chat'
import { globalStore } from '@store/index'

export default {
  getApiServerUrl(): string {
    const apiServerUrl = globalStore.findGlobalSetting(GlobalStoreKey.V2_API_SERVER_URL)
    return apiServerUrl.value
  },
  getConfig(): { withCredentials: boolean, paramsSerializer: any, headers: Record<string, string> } {
    return {
      withCredentials: false,
      headers: {
        'Content-Type': 'multipart/form-data',
        [V2_API_HEADER.ACCESS_TOKEN]: V2_API_HEADER.ACCESS_TOKEN_VALUE,
      },
      paramsSerializer: (params: any) => {
        return qs.stringify(params, { arrayFormat: 'repeat' })
      }
    }
  },
  async postData(url, formData) {
    const apiServerUrl = this.getApiServerUrl()
    const config = this.getConfig()
    return http.post(url, formData || {}, apiServerUrl, config)
  },
  async getData(url, params) {
    const apiServerUrl = this.getApiServerUrl()
    const config = this.getConfig()
    return http.get(url, params, apiServerUrl, config)
  },
  async uploadCompanyPickCommentImageFile(data: File): Promise<IImageUpload.Schema> {
    const formData = new FormData()
    formData.append('imageFile', data)
    return this.postData(V2_API_URL.UPLOAD_COMPANY_PICK_COMMENT_IMAGE, formData)
  },
  async uploadChatImageFile(data: File): Promise<IImageUpload.Schema> {
    const formData = new FormData()
    formData.append('imageFile', data)
    return this.postData(V2_API_URL.UPLOAD_CHAT_IMAGE, formData)
  },
  async uploadUserProfileImageFile(data: File): Promise<IImageUpload.Schema> {
    const formData = new FormData()
    formData.append('imageFile', data)
    return this.postData(V2_API_URL.UPLOAD_USER_PROFILE_IMAGE, formData)
  },
  async getSimpleMatchTimelineGroup(matchId: number, withTimelineEvent: boolean): Promise<SimpleMatchTimelineGroup> {
    const result = await this.getData(V2_API_URL.SIMPLE_MATCH_TIMELINE_GROUP_LIST,
      { matchIds: [matchId], withTimelineEvent })
    if (_.isEmpty(result)) {
      return null
    }
    return result[0]
  },
}
